import React from "react";
import { useTranslation } from "react-i18next";
import {
    StyledLabel,
    StyledTextInput,
    StyledSelectInput,
} from "@aureskonnect/react-ui";
import { AvGroup } from "availity-reactstrap-validation";
import classnames from "classnames";
import PhoneInput from "react-phone-input-2";

import { setIsEdited } from "../store";

import { CustomCardBody } from "@components/Common/CustomCardStyled";
import { activities } from "@constants/index";

import "@assets/swal.css";
import "@assets/theme.css";
import "react-toastify/dist/ReactToastify.css";
import "antd/dist/antd.css";

export function CreateOrganizationBody({ data }: any) {
    const { t } = useTranslation();
    let selectedCountryCode = localStorage.getItem("selectedCountryCode");

    return (
        <CustomCardBody
            className={`pl-3 pr-5 `}
            style={{
                maxHeight: "470px",
                overflowY: " auto",
            }}
        >
            {data.isConsult ? (
                <AvGroup className={`${data.isConsult ? "pe-none__clz" : ""}`}>
                    <StyledLabel htmlFor="text" className="required__clz mt-3">
                        {t("Organization Id")}
                    </StyledLabel>
                    <StyledTextInput
                        autocomplete="off"
                        id="id"
                        name="id"
                        placeholder={t("Write")}
                        type="text"
                        onChange={(e: any) => {
                            data.setOrganizationId(e.target.value);
                            data.setInputOrganizationId(false);
                            setIsEdited(true);
                        }}
                        value={data.organizationId}
                        className={classnames("", {
                            invalid__clz: data.inputOrganizationId,
                        })}
                    />
                    {data.inputOrganizationId ? (
                        <div
                            style={{
                                width: "100%",
                                marginTop: "0.25rem",
                                fontSize: "80%",
                                color: "#f46a6a",
                            }}
                        >
                            {t("Please enter the organization Id")}
                        </div>
                    ) : null}
                </AvGroup>
            ) : null}
            <AvGroup className={`${data.isConsult ? "pe-none__clz" : ""}`}>
                <StyledLabel htmlFor="text" className="required__clz mt-3">
                    {t("Organization name")}
                </StyledLabel>
                <StyledTextInput
                    autocomplete="off"
                    id="organizationName"
                    name="organizationName"
                    placeholder={t("Write")}
                    type="text"
                    onChange={(e: any) => {
                        data.setOrganizationName(e.target.value);
                        data.setInputOrganizationName(false);
                        setIsEdited(true);
                    }}
                    value={data.organizationName}
                    className={classnames("", {
                        invalid__clz: data.inputOrganizationName,
                    })}
                />
                {data.inputOrganizationName ? (
                    <div
                        style={{
                            width: "100%",
                            marginTop: "0.25rem",
                            fontSize: "80%",
                            color: "#f46a6a",
                        }}
                    >
                        {t("Please enter the organization name")}
                    </div>
                ) : null}
            </AvGroup>
            <AvGroup className={`${data.isConsult ? "pe-none__clz" : ""}`}>
                <StyledLabel htmlFor="text" className="required__clz mt-3">
                    {t("Activity type")}
                </StyledLabel>
                <StyledSelectInput
                    options={activities.map((el: any) => {
                        return { ...el, label: t(el.label) };
                    })}
                    autoComplete="off"
                    placeholder={`${t("Select")}…`}
                    value={
                        data.activityType === ""
                            ? null
                            : {
                                  label: t(data.activityType),
                                  value: data.activityType,
                              }
                    }
                    onChange={(e: any) => {
                        data.setActivityType(e.value);
                        data.setInputActivityType(false);
                        setIsEdited(true);
                    }}
                    noOptionsMessage={() => t("No options")}
                    name={t("activityType")}
                    autoFocus
                    className={classnames("", {
                        invalid__clz: data.inputActivityType,
                    })}
                />
                {data.inputActivityType ? (
                    <div
                        style={{
                            width: "100%",
                            marginTop: "0.25rem",
                            fontSize: "80%",
                            color: "#f46a6a",
                        }}
                    >
                        {t("Please chose a role")}
                    </div>
                ) : null}
            </AvGroup>
            <StyledLabel htmlFor="text" className=" mt-3">
                {t("Contact point")}
            </StyledLabel>
            <span className="d-flex justify-content-between">
                <AvGroup className={`${data.isConsult ? "pe-none__clz" : ""}`}>
                    <StyledLabel className="required__clz mt-3" htmlFor="name">
                        {t("Name")}
                    </StyledLabel>
                    <StyledTextInput
                        autocomplete="off"
                        id="name"
                        name="name"
                        placeholder={t("Write")}
                        type="text"
                        onChange={(e: any) => {
                            data.setLastName(e.target.value);
                            data.setInputLastName(false);
                            setIsEdited(true);
                        }}
                        value={data.lastName}
                        className={classnames("", {
                            invalid__clz: data.inputLastName,
                        })}
                    />
                    {data.inputLastName ? (
                        <div
                            style={{
                                width: "100%",
                                marginTop: "0.25rem",
                                fontSize: "80%",
                                color: "#f46a6a",
                            }}
                        >
                            {t("Please enter a name")}
                        </div>
                    ) : null}
                </AvGroup>
                <AvGroup className={`${data.isConsult ? "pe-none__clz" : ""}`}>
                    <StyledLabel className="required__clz mt-3" htmlFor="name">
                        {t("FirstName")}
                    </StyledLabel>
                    <StyledTextInput
                        autocomplete="off"
                        id="firstName"
                        name="firstName"
                        placeholder={t("Write")}
                        type="text"
                        onChange={(e: any) => {
                            data.setFirstName(e.target.value);
                            data.setInputFirstName(false);
                            setIsEdited(true);
                        }}
                        value={data.firstName}
                        className={classnames("", {
                            invalid__clz: data.inputFirstName,
                        })}
                    />
                    {data.inputFirstName ? (
                        <div
                            style={{
                                width: "100%",
                                marginTop: "0.25rem",
                                fontSize: "80%",
                                color: "#f46a6a",
                            }}
                        >
                            {t("Please enter a first name")}
                        </div>
                    ) : null}
                </AvGroup>
            </span>
            <AvGroup className={`${data.isConsult ? "pe-none__clz" : ""}`}>
                <StyledLabel className="required__clz mt-3" htmlFor="name">
                    {t("Email")}
                </StyledLabel>
                <StyledTextInput
                    autocomplete="off"
                    id="email"
                    name="email"
                    placeholder={t("Write")}
                    type="email"
                    onChange={(e: any) => {
                        data.setEmail(e.target.value);
                        data.setInputEmail(false);
                        setIsEdited(true);
                    }}
                    value={data.email}
                    className={classnames("", {
                        invalid__clz: data.inputEmail,
                    })}
                    validate={{
                        email: {
                            value: true,
                            errorMessage: t("Invalid email address"),
                        },
                    }}
                />
                {data.inputEmail ? (
                    <div
                        style={{
                            width: "100%",
                            marginTop: "0.25rem",
                            fontSize: "80%",
                            color: "#f46a6a",
                        }}
                    >
                        {t("Please enter email")}
                    </div>
                ) : null}
            </AvGroup>
            <AvGroup className={`${data.isConsult ? "pe-none__clz" : ""}`}>
                <StyledLabel className="required__clz mt-3" htmlFor="name">
                    {t("Phone number")}
                </StyledLabel>
                <PhoneInput
                    buttonClass="ctl_btn_firstPhoneNumber"
                    inputClass="ctl_inp_firstPhoneNumber"
                    country={
                        data.isoCode !== ""
                            ? data.isoCode
                            : (selectedCountryCode as string)
                    }
                    value={data.phoneNumber}
                    onChange={(e: any, country: any) => {
                        data.setCode(country.dialCode);
                        data.setPhoneNumber(e);
                        data.setInputPhoneNumber(false);
                        setIsEdited(true);
                    }}
                    placeholder={t("Saisir")}
                />
                {data.inputPhoneNumber ? (
                    <div
                        style={{
                            width: "100%",
                            marginTop: "0.25rem",
                            fontSize: "80%",
                            color: "#f46a6a",
                        }}
                    >
                        {t("Please enter phone number")}
                    </div>
                ) : null}
            </AvGroup>
            <StyledLabel htmlFor="text" className=" mt-3">
                {t("Billing address")}
            </StyledLabel>
            <AvGroup className={`${data.isConsult ? "pe-none__clz" : ""}`}>
                <StyledLabel className="required__clz mt-3" htmlFor="name">
                    {t("Address")}
                </StyledLabel>
                <StyledTextInput
                    autocomplete="off"
                    id="address"
                    name="address"
                    placeholder={t("Write")}
                    type="text"
                    onChange={(e: any) => {
                        data.setAddress(e.target.value);
                        data.setInputAddress(false);
                        setIsEdited(true);
                    }}
                    value={data.address}
                    className={classnames("", {
                        invalid__clz: data.inputAddress,
                    })}
                />
                {data.inputAddress ? (
                    <div
                        style={{
                            width: "100%",
                            marginTop: "0.25rem",
                            fontSize: "80%",
                            color: "#f46a6a",
                        }}
                    >
                        {t("Please enter an address")}
                    </div>
                ) : null}
            </AvGroup>
            <span className="d-flex justify-content-between">
                <AvGroup className={`${data.isConsult ? "pe-none__clz" : ""}`}>
                    <StyledLabel className="required__clz mt-3" htmlFor="name">
                        {t("Zip code")}
                    </StyledLabel>
                    <StyledTextInput
                        autocomplete="off"
                        id="zipCode"
                        name="zipCode"
                        placeholder={t("Write")}
                        type="text"
                        onChange={(e: any) => {
                            data.setPostalCode(e.target.value);
                            data.setInputPostalCode(false);
                            setIsEdited(true);
                        }}
                        value={data.postalCode}
                        className={classnames("", {
                            invalid__clz: data.inputPostalCode,
                        })}
                    />
                    {data.inputPostalCode ? (
                        <div
                            style={{
                                width: "100%",
                                marginTop: "0.25rem",
                                fontSize: "80%",
                                color: "#f46a6a",
                            }}
                        >
                            {t("Please enter zip code")}
                        </div>
                    ) : null}
                </AvGroup>
                <AvGroup className={`${data.isConsult ? "pe-none__clz" : ""}`}>
                    <StyledLabel className="required__clz mt-3" htmlFor="name">
                        {t("City")}
                    </StyledLabel>
                    <StyledTextInput
                        autocomplete="off"
                        id="city"
                        name="city"
                        placeholder={t("Write")}
                        type="text"
                        onChange={(e: any) => {
                            data.setCity(e.target.value);
                            data.setInputCity(false);
                            setIsEdited(true);
                        }}
                        value={data.city}
                        className={classnames("", {
                            invalid__clz: data.inputCity,
                        })}
                    />
                    {data.inputCity ? (
                        <div
                            style={{
                                width: "100%",
                                marginTop: "0.25rem",
                                fontSize: "80%",
                                color: "#f46a6a",
                            }}
                        >
                            {t("Please enter a city")}
                        </div>
                    ) : null}
                </AvGroup>
            </span>
            <AvGroup className={`${data.isConsult ? "pe-none__clz" : ""}`}>
                <StyledLabel htmlFor="text" className="required__clz mt-3">
                    {t("Country")}
                </StyledLabel>
                <StyledTextInput
                    autocomplete="off"
                    id="city"
                    name="city"
                    placeholder={t("Write")}
                    type="text"
                    onChange={(e: any) => {
                        data.setCity(e.target.value);
                        data.setInputCity(false);
                        setIsEdited(true);
                    }}
                    value={data.country}
                    className="not-allowed-input__clz"
                />
            </AvGroup>
        </CustomCardBody>
    );
}
